import { FocusMonitor } from '@angular/cdk/a11y';
import {
  Component,
  ContentChild,
  ElementRef,
  Input,
  Optional,
  Self,
} from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';

import { BaseMatControlComponent } from '../../base-mat-control.component';

@Component({
  selector: 'app-easy-checkbox',
  templateUrl: './easy-checkbox.component.html',
  styleUrls: ['./easy-checkbox.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: EasyCheckboxComponent },
  ],
})
export class EasyCheckboxComponent extends BaseMatControlComponent<boolean> {
  @ContentChild('content') content?: ElementRef;

  @Input() color?: string;

  constructor(
    @Optional() @Self() public override ngControl: NgControl,
    protected override formBuilder: FormBuilder,
    protected override focusMonitor: FocusMonitor,
    protected override elRef: ElementRef
  ) {
    super(ngControl, formBuilder, focusMonitor, elRef);

    this.controlIdentity = 'easy-checkbox';
    this.controlType = 'mat-checkbox';
  }

  checkboxClicked(event: MouseEvent) {
    if (this.readonly) {
      event.preventDefault();
    }
  }
}
